import { FC } from "react";
import styles from './configurator-header.module.css'

import { useMessages2 } from "../../hooks/useLanguage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { showPopup } from "../../app/popup-slice";
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { Link } from "react-router-dom";
import { isClassicModelSelector } from '../../app/configurator-slice';
import { Logo } from '../logo/logo';

export type ConfiguratorHeaderProps = {
    modelName: string
    className?: string
    urlBack?: string
}

export const ConfiguratorHeader: FC<ConfiguratorHeaderProps> = ({modelName, className, urlBack }) => {

    const { messages} = useMessages2();
    const dispatch = useAppDispatch();
    const isClassicModel = useAppSelector(isClassicModelSelector);

    const onHandleInfo = () => {
        dispatch(showPopup({dialog: 'infoModel', popupContent: {modelName: modelName}}))
    }

    return(
        <div className={`${styles.configuratorHeaderContainer} ${className}`}>
            <Logo/>
            <div className={styles.modelName}>
                <h2>{modelName}&nbsp;
                    <span onClick={onHandleInfo}>
                        <FontAwesomeIcon icon={faCircleInfo} className={styles.infoIcon} />
                    </span>
                </h2>
            </div>

            { isClassicModel ? <div className={styles.classicInfo}>{ messages?.classics_info }</div> : null }

            { urlBack ?
                <Link to={urlBack} className={styles.backButton}>
                    <FontAwesomeIcon icon={faChevronLeft}/> 
                </Link>
                :
                null
            }
        </div>
    )
}